import { Button, Flex, Space, Text } from '@mantine/core';
import classes from '../../../../sharedStyles/InfoCard.module.css';
import { BaseLayout } from '../../navigation';
import {
  Header,
  LoyalityPointInfo,
  NachversandHomeBanner,
  QuestionnaireBanner,
  WonRaffleBanner,
} from './components';
import { observer } from 'mobx-react';
import { useUserMeStore } from '../../../../store';
import {
  CohortType,
  LoyalityPointsLogReason,
  MissionType,
} from '@prisma/client';
import { DateTime } from 'luxon';
import { useWindowSize } from '../../../../hooks';
import { MissionWrapper } from './components';
import { useMissionStore } from '../../../../store/MissionStore';
import { useEffect } from 'react';
import { LogoutButton } from '../../../../component';
import { useTranslation } from 'react-i18next';
import {
  ErrorCode,
  FeatureFlag,
  SURVEY_DETECTION_WINDOW_WEEKS,
} from '@web/common';
import { DevContent } from '../../../../util/DevContent';
import {
  showErrorNotification,
  showFailedRequestNotification,
  showPointsAwardedNotification,
  showSuccessNotification,
} from '../../../../component/notification';
import useRedirect from '../../../../hooks/useRedirect';
import { FeatureAccess } from '../../../../util/ff/FeatureAccess';
import { RaffleSection } from '../raffles/components/raffle-section';
import { QuestionnaireAndVoucherCard } from './components/questionnaire-and-voucher';
import { isQuestionnaireMission, isWithinDetectionWindow } from './utils';

export const HomeScreen = observer(() => {
  const missionStore = useMissionStore();
  const missions = missionStore.missions;
  const isSmallScreen = useWindowSize(500);
  const { t } = useTranslation('homescreen');
  useRedirect();

  const myInfoStore = useUserMeStore();
  const cohortType = myInfoStore.myInfo?.Participant?.cohortType;
  const isControlGroup = cohortType === CohortType.CONTROL_GROUP;

  const detectionWindowStart = DateTime.now()
    .minus({ weeks: SURVEY_DETECTION_WINDOW_WEEKS })
    .plus({ days: 1 })
    .startOf('day');

  const questionnaireMission = missions.find(
    (mission) =>
      isQuestionnaireMission(mission) &&
      isWithinDetectionWindow(mission, detectionWindowStart),
  );

  useEffect(() => {
    missionStore.completeMission(MissionType.WeeklyLogin);
  }, [missionStore]);

  return (
    <BaseLayout hideNavbar={isControlGroup}>
      <Flex
        direction="column"
        maw={1100}
        gap={20}
        bg="#fff"
        p={isSmallScreen ? 20 : 40}
        className={classes.borderRadius}
      >
        <Header />

        <FeatureAccess flag={FeatureFlag.Raffles}>
          <WonRaffleBanner />
        </FeatureAccess>

        <Space />
        <NachversandHomeBanner />
        {questionnaireMission && (
          <QuestionnaireBanner mission={questionnaireMission} />
        )}

        <Flex gap="24px" direction="row" wrap="nowrap" align="stretch">
          <div style={{ flex: 1 }}>
            <LoyalityPointInfo />
          </div>

          <div style={{ flex: 1 }}>
            <QuestionnaireAndVoucherCard />
          </div>
        </Flex>

        <Flex gap="24px" align="flex-start" wrap="wrap">
          <div style={{ flex: 1 }}>
            <MissionWrapper />
          </div>
        </Flex>

        <FeatureAccess flag={FeatureFlag.Raffles}>
          <RaffleSection />
        </FeatureAccess>

        {isControlGroup && (
          <Flex gap={20} direction="column" maw="200px">
            <Space h="lg" />
            <Text lh="24px" size="21px" fw="500">
              {t('Settings')}
            </Text>
            <LogoutButton />
          </Flex>
        )}

        <DevContent>
          <Button
            onClick={() =>
              showPointsAwardedNotification(
                100,
                LoyalityPointsLogReason.LoggedIn,
                2050,
              )
            }
          >
            showPointsAwardedNotification
          </Button>
          <Button onClick={() => showSuccessNotification('Text', 'Title')}>
            showSuccessNotification
          </Button>
          <Button
            onClick={() =>
              showFailedRequestNotification(
                ErrorCode.GenericError,
                'tracing uuid',
              )
            }
          >
            showFailedRequestNotification
          </Button>
          <Button
            onClick={() =>
              showErrorNotification(ErrorCode.GenericError, 'tracing uuid')
            }
          >
            showFailedRequestNotification
          </Button>
        </DevContent>
      </Flex>
    </BaseLayout>
  );
});
